module.exports = __webpack_public_path__ + "img/endurance.3e8ca8ce.png";